import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgBlu = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='#000'
      d='M5.705 6.402a.95.95 0 1 0 0-1.902.95.95 0 0 0 0 1.902'
    />
    <path
      fill='#4E91E6'
      d='M18.067 10.633v4.517c0 .999.74 1.76 1.712 1.76.962 0 1.712-.762 1.711-1.73v-4.547c0-.656.533-1.188 1.19-1.188h1.188v5.61a4.089 4.089 0 1 1-8.178 0v-5.61h1.189c.656 0 1.188.532 1.188 1.188'
    />
    <path
      fill='#4E91E6'
      fillRule='evenodd'
      d='M12.6 5.831h1.188v12.124c0 .657-.532 1.19-1.188 1.19H11.41V7.02c0-.657.532-1.189 1.189-1.189'
      clipRule='evenodd'
    />
    <path
      fill='#4E91E6'
      d='M2.377 5.831v4.514c.753-.682 1.712-1.09 2.758-1.09 2.416 0 4.374 2.182 4.374 4.873v.119c0 2.781-2.129 4.897-4.754 4.897-2.58 0-4.68-2.116-4.753-4.754H0V7.02C0 6.36.538 5.83 1.189 5.83zm2.33 5.61c-1.365 0-2.472 1.225-2.472 2.734 0 1.51 1.107 2.734 2.472 2.734s2.472-1.224 2.472-2.733-1.107-2.734-2.472-2.734'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgBlu)
export default ForwardRef
